module.exports = __webpack_public_path__ + "static/media/peacock_walk.7332ff14.gif";